<div
  class="ctn-image-disney"
  [ngClass]="{ almundo: brand === 'almundo', avantrip: brand === 'avantrip' }"
></div>
<div class="ctn-description">
  <div class="title">
    <p>Beneficios al alojarte dentro de los parques.</p>
    <h5>Hotel Resort <i>Disney</i></h5>
  </div>
  <ul>
    @for (benefit of benefitsDisney; track $index) {
      <li>
        <mb-icon icon="check-simple"></mb-icon>
        <p>{{ benefit }}</p>
      </li>
    }
  </ul>
</div>
